/* eslint-disable camelcase */
import React, { createContext, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Skeleton } from '../../Common';
import ShowAt from '../../Common/ShowAt/ShowAt';
import CloseOrder from '../../Pages/CreateHPool/CreateHPoolSignTransaction/EditTradeOrders/OrdersTabs/NewOrder/VpoolOrders/CloseOrder/CloseOrder';
import ModalBody from '../ModalBody';
import { getTokenSymbol } from '../../../utils/format';
import { compareStrings } from '../../../utils/mapper';
import Tabs from '../../Common/Tabs/Tabs';
import OpenOrder from '../../Pages/CreateHPool/CreateHPoolSignTransaction/EditTradeOrders/OrdersTabs/NewOrder/VpoolOrders/OpenOrder/OpenOrder';
import ClosePortion from '../../Pages/CreateHPool/CreateHPoolSignTransaction/EditTradeOrders/OrdersTabs/NewOrder/VpoolOrders/ClosePortion/ClosePortion';

export const ManualOrderContext = createContext({
  passedValues: null,
  orderInfo: null,
  onSubmit: () => {},
});

function ManualOrderModals({ closeModal, modalInfo, hpool }) {
  useEffect(() => {}, []);
  const { hasManualOrders: manualOrder = {} } = modalInfo;
  const { assets = [] } = hpool;
  const { id: orderId } = manualOrder;

  const orderInfoFromAssets =
    assets.find((asset) => compareStrings(getTokenSymbol(asset), getTokenSymbol(manualOrder))) || {};

  const { order_type, token_id, id } = manualOrder;
  const {
    champion_price: finalTokenPrice,
    total_tokens_to_receive: totalTokensToBeReceived,
    public_price,
    chain_of_origin,
    token_symbol: tokenToReceiveSymbol,
    token_address: tokenAddress,
    master_address,
    lp_address,
    end_of_vesting,
    end_of_cliff,
    base_token_purchase_amount: amountUSDToWithdraw = 0,
    base_token_purchase_amount,
    token_pair = ' ',
  } = { ...orderInfoFromAssets, ...manualOrder, id };

  const [baseToken, tokenToWithdrawSymbol] = token_pair.split('/') || ['', ''];
  const passedValues = {
    finalTokenPrice,
    totalTokensToBeReceived,
    public_price,
    chain_of_origin,
    master_address,
    lp_address,
    end_of_vesting,
    end_of_cliff,
    tokenToReceiveSymbol,
    tokenAddress,
    amountUSDToWithdraw,
    stableCoinSymbol: tokenToWithdrawSymbol,
    amountOfTokensToReturn: totalTokensToBeReceived,
    token_id,
    orderId,
  };

  const contextValue = {
    passedValues,
    orderInfo: { ...orderInfoFromAssets, id: orderId }, // override the id, to avoid mixing token id with order id
    onSubmit: () => closeModal(),
  };

  return (
    <div className="join-pool-container">
      <ManualOrderContext.Provider value={contextValue}>
        <ModalBody title="modal.sign_manual_orders" closeModal={closeModal}>
          <Tabs initCurrentTab={order_type} tabs={[]} TabPicker={() => <></>}>
            <Tabs.Tab tab="MANUAL_OPEN_ORDER">
              <OpenOrder />
            </Tabs.Tab>
            <Tabs.Tab tab="MANUAL_CLOSE_ORDER">
              <CloseOrder />
            </Tabs.Tab>
            <Tabs.Tab tab="MANUAL_CLOSE_PORTION">
              <ClosePortion />
            </Tabs.Tab>
          </Tabs>
        </ModalBody>
      </ManualOrderContext.Provider>
    </div>
  );
}

const mapStateToProps = (state) => ({
  account: state.wallet.account,
  modalInfo: state.modal.modalProps,
  hpool: state.createHPool.hpool,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ManualOrderModals);

ManualOrderModals.defaultProps = {};

ManualOrderModals.propTypes = {
  closeModal: PropTypes.func.isRequired,
  modalInfo: PropTypes.object.isRequired,
  hpool: PropTypes.object.isRequired,
};
